module.exports = __webpack_public_path__ + "img/l_r_vid_4_splash.fcf252e5.jpg";